import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS } from '../types/auth';
import { CLEAR_SESSION_DATA, SET_INVESTOR_RM_ID } from '../types/sessionData';

export type SessionDataType = {
    investorRmId: string;
};

const initState: Partial<SessionDataType> = {
    investorRmId: ""
};

export default function sessionDataReducer(state = initState, action: AnyAction): Partial<SessionDataType> {
    switch (action.type) {
        case SET_INVESTOR_RM_ID: {
            return {
                ...state,
                investorRmId: action.investorRmId,
            };
        }
        case LOGOUT_SUCCESS:
        case CLEAR_SESSION_DATA: {
            return {
                ...initState
            }
        }
        default:
            return state;
    }
}